import React from "react";
import { getPlanApiAccessItems } from "../../utils/planApiAccess";

const UPDATE_FEATURE_IDS = new Set([
  "data_updates_60s",
  "data_updates_realtime",
]);

const renderAccessItem = (item) => (
  <li
    key={item.id}
    className={item.included ? "" : "text-muted"}
    style={item.included ? undefined : { opacity: 0.85 }}
  >
    <span style={{ color: item.included ? undefined : "#dc3545" }}>
      <i
        className={`fa-solid ${item.included ? "fa-check" : "fa-times"}`}
      ></i>
    </span>{" "}
    {item.label}
  </li>
);

const PlanApiAccessList = ({
  planBackendName,
  apiCallsLabel,
  title = "API Access",
  titleClassName = "h4 mb-2",
  listClassName = "list mb-0",
}) => {
  const items = getPlanApiAccessItems(planBackendName);
  const updateItems = items.filter((item) => UPDATE_FEATURE_IDS.has(item.id));
  const apiItems = items.filter((item) => !UPDATE_FEATURE_IDS.has(item.id));

  return (
    <div>
      {title ? <div className={titleClassName}>{title}</div> : null}
      <ul className={listClassName}>
        {apiCallsLabel && (
          <li>
            <span>
              <i className="fa-solid fa-check"></i>
            </span>{" "}
            {apiCallsLabel}
          </li>
        )}
        {updateItems.map(renderAccessItem)}
        {apiItems.map(renderAccessItem)}
      </ul>
    </div>
  );
};

export default PlanApiAccessList;
